<a
  [routerLink]="routerLink"
  [queryParams]="queryParams"
  [fragment]="fragment"
  [cignaTrackClicks]="cignaTrackClicks"
  ><ng-content></ng-content
></a>
